import { EVENT_STATUS } from "../js/constants";

export default ({ status }) => {
  if (status === "") {
    return null;
  }

  const eventStatus = EVENT_STATUS.find(
    (item) => item.id === status || `${item.id}` === `${status}`,
  );

  return (
    <div
      className="calendar-status"
      style={{
        backgroundColor: eventStatus ? eventStatus.color : "",
      }}
    />
  );
};
